import axios from 'axios';
import { Country } from '@/models/country';

const apiHost = process.env.VUE_APP_API_HOST;

export const fetchProducts = async (country: Country, phonenumber: string) => {
  const response = await axios.post(`${apiHost}/ringcredible/v5/websiteshop/products.json`, {
    country: country.code,
    phonenumber,
  });
  return response.data;
};

export const submitOrder = async (
  currency: string,
  country: Country,
  phonenumber: string,
  code: string | null,
  packId: number,
  autoRecharge: boolean | null,
  lang: string,
) => {
  const mobile = window.innerWidth < 800;
  const response = await axios.post(`${apiHost}/ringcredible/v5/websiteshop/order`, {
    currency,
    country: country.code,
    phonenumber,
    ...(code === null ? {} : { promocode: code }),
    mobile,
    product_id: packId,
    ...(autoRecharge === null ? {} : { recurring: autoRecharge }),
    lang,
  });
  return response.data.adyen_redirect_url;
};
